'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _redboxReact2 = require('redbox-react');

var _redboxReact3 = _interopRequireDefault(_redboxReact2);

var _react2 = require('react');

var _react3 = _interopRequireDefault(_react2);

var _reactTransformCatchErrors3 = require('react-transform-catch-errors');

var _reactTransformCatchErrors4 = _interopRequireDefault(_reactTransformCatchErrors3);

var _reactBootstrap = require('react-bootstrap');

require('./AdressListInput.less');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var _components = {
    AddressListInputView: {
        displayName: 'AddressListInputView'
    }
};

var _reactTransformCatchErrors2 = (0, _reactTransformCatchErrors4.default)({
    filename: '/usr/local/ibonus/src/components/AddressListInput/default/AddressListInputView.jsx',
    components: _components,
    locals: [],
    imports: [_react3.default, _redboxReact3.default]
});

function _wrapComponent(id) {
    return function (Component) {
        return _reactTransformCatchErrors2(Component, id);
    };
}

var AddressListInputView = _wrapComponent('AddressListInputView')(function (_React$Component) {
    (0, _inherits3.default)(AddressListInputView, _React$Component);

    function AddressListInputView() {
        (0, _classCallCheck3.default)(this, AddressListInputView);
        return (0, _possibleConstructorReturn3.default)(this, (AddressListInputView.__proto__ || (0, _getPrototypeOf2.default)(AddressListInputView)).apply(this, arguments));
    }

    (0, _createClass3.default)(AddressListInputView, [{
        key: 'render',
        value: function render() {
            var _props = this.props,
                lang = _props.lang,
                is_default = _props.is_default,
                isNew = _props.isNew,
                onSave = _props.onSave,
                editMode = _props.editMode,
                setEditMode = _props.setEditMode,
                value = _props.value,
                onChange = _props.onChange,
                onCancel = _props.onCancel,
                onMapButtonClick = _props.onMapButtonClick,
                onDeleteButtonClick = _props.onDeleteButtonClick,
                onDefaultButtonClick = _props.onDefaultButtonClick;


            var isEditButtonShown = !editMode && !isNew;
            var isMapButtonShown = editMode;
            var isDefaultButtonShown = !editMode && !isNew;
            var isSaveButtonShown = editMode;
            var isDeleteButtonShown = !editMode && !isNew;
            var isCancelButtonShown = editMode;

            return _react3.default.createElement(
                'div',
                { className: 'address-input__container' },
                _react3.default.createElement(_reactBootstrap.FormControl, { onChange: onChange, value: value, disabled: !editMode, type: 'text' }),
                isEditButtonShown && _react3.default.createElement(
                    'button',
                    { onClick: function onClick() {
                            return setEditMode(true);
                        }, className: 'le-button pay_order_button' },
                    lang['store.common.addresses.edit']
                ),
                isSaveButtonShown && _react3.default.createElement(
                    'button',
                    { disabled: !value, onClick: onSave, className: 'le-button pay_order_button' },
                    lang['store.common.addresses.save']
                ),
                isMapButtonShown && _react3.default.createElement(
                    'button',
                    { onClick: onMapButtonClick, className: 'le-button pay_order_button' },
                    lang['store.common.select_on_map']
                ),
                isCancelButtonShown && _react3.default.createElement(
                    'button',
                    { onClick: onCancel, className: 'le-button pay_order_button' },
                    lang['store.common.addresses.cancel']
                ),
                isDefaultButtonShown && _react3.default.createElement(
                    'button',
                    { onClick: onDefaultButtonClick, disabled: is_default, className: 'le-button pay_order_button ' + (is_default && 'disabled') },
                    lang['store.common.addresses.default']
                ),
                isDeleteButtonShown && _react3.default.createElement(
                    'button',
                    { onClick: onDeleteButtonClick, className: 'le-button pay_order_button' },
                    lang['store.common.addresses.delete']
                )
            );
        }
    }]);
    return AddressListInputView;
}(_react3.default.Component));

exports.default = AddressListInputView;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/AddressListInput/default/AddressListInputView.jsx
// module id = 745
// module chunks = 0